export default "__VITE_ASSET__fbc4dc57__"